webpackJsonp([4],{

/***/ "+iUi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios_retry__ = __webpack_require__("UdGm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios_retry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios_retry__);



/* harmony default export */ __webpack_exports__["a"] = (function (options) {
  var client = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create(options);
  __WEBPACK_IMPORTED_MODULE_1_axios_retry___default()(client, {
    // retryCondition (error) {
    //   // error.code === 'ECONNABORTED' // Retry timed out requests
    // }
  });
  return client;
});

/***/ }),

/***/ "1aY9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_touch__ = __webpack_require__("I0MY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_touch__);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_touch___default.a);

/***/ }),

/***/ "6ecI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var deferred = {};
  deferred.promise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    deferred.resolve = resolve;
    deferred.reject = reject;
  });
  return deferred;
});

/***/ }),

/***/ "7H/B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "A2jV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
function install(Vue) {
  if (install.installed) return;
  install.installed = true;

  Object.defineProperty(Vue.prototype, '$stock', {
    get: function get() {
      return this.$root._stock;
    }
  });

  Vue.mixin({
    beforeCreate: function beforeCreate() {
      if (this.$options.stock) {
        this._stock = this.$options.stock;
      }
    }
  });
}

/***/ }),

/***/ "AQnU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = mapQuote;
/* harmony export (immutable) */ __webpack_exports__["d"] = mapQuotes;
/* harmony export (immutable) */ __webpack_exports__["c"] = mapQuoteSimple;
/* harmony export (immutable) */ __webpack_exports__["f"] = mapStarStock;
/* harmony export (immutable) */ __webpack_exports__["a"] = mapHotestStock;
/* harmony export (immutable) */ __webpack_exports__["e"] = mapSearchResult;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__("5dBV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);

function mapQuote(quote) {
  var arr = quote.split(',');
  return {
    name: arr[0],
    open: arr[1],
    prevClose: arr[2],
    lastTrade: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(arr[3]).toFixed(2),
    highest: arr[4],
    lowest: arr[5],
    bid: arr[6],
    ask: arr[7],
    volume: arr[4],
    turnover: arr[5],
    change: arr[3] - arr[2],
    chg: (arr[3] - arr[2]) / arr[2],
    isSuspension: arr[arr.length - 1] === '03',
    exit_market: arr[arr.length - 1] === '-3',
    no_in_market: arr[arr.length - 1] === '-2',
    no_data: arr[arr.length - 1] === '-1'
  };
}

function mapQuotes(quote) {
  var arr = quote.split(',');
  return {
    Condition: arr[arr.length - 4] === '3'
  };
}

function mapQuoteSimple(quote) {
  var arr = quote.split(',');
  return {
    name: arr[0],
    lastTrade: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(arr[1]).toFixed(2),
    change: arr[2],
    chg: arr[3] / 100,
    volume: arr[4],
    turnover: arr[5]
  };
}

function mapStarStock(stock) {
  return {
    name: stock.stock,
    hs300: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(stock.hs300) / 100,
    rate: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(stock.margin) / 100,
    market: stock.market,
    comment: stock.result,
    symbol: stock.symbol,
    theme: stock.concept,
    date: stock.date
  };
}

function mapHotestStock(stock) {
  return {
    name: stock.stock,
    symbol: stock.symbol
  };
}

function mapSearchResult(stock) {
  var fields = stock.split(',');
  return {
    symbol: fields[3],
    type: fields[1],
    name: fields[4],
    abbr: fields[5]
  };
}

/***/ }),

/***/ "HARo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_easy_toast__ = __webpack_require__("UV/M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_easy_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_easy_toast__);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_easy_toast___default.a);

var defaultOptions = {
  duration: 3000,
  horizontalPosition: 'center',
  verticalPosition: 'bottom'
};

var vueEasyToast = __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toast;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$toast = function (message) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOptions;

  vueEasyToast(message, options);
};

/***/ }),

/***/ "Kghx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toCamel;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_to_case__ = __webpack_require__("j5ZN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_to_case___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_to_case__);



function toCamel(obj) {
  var newObj = {};

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj).forEach(function (key) {
    if (obj[key] instanceof Object) {
      newObj[Object(__WEBPACK_IMPORTED_MODULE_1_to_case__["camel"])(key)] = toCamel(obj[key]);
    } else {
      newObj[Object(__WEBPACK_IMPORTED_MODULE_1_to_case__["camel"])(key)] = obj[key];
    }
  });

  return newObj;
}

/***/ }),

/***/ "LpSC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return sinaClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return proxyClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return apiClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return decodeClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return appClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return accumulateClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stockStatisticsClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_helpers_create_axios_instance__ = __webpack_require__("+iUi");


var sinaClient = Object(__WEBPACK_IMPORTED_MODULE_0_helpers_create_axios_instance__["a" /* default */])({ timeout: 10000 });
var proxyClient = Object(__WEBPACK_IMPORTED_MODULE_0_helpers_create_axios_instance__["a" /* default */])({ timeout: 10000 });
var apiClient = Object(__WEBPACK_IMPORTED_MODULE_0_helpers_create_axios_instance__["a" /* default */])({ timeout: 5000 });
var decodeClient = Object(__WEBPACK_IMPORTED_MODULE_0_helpers_create_axios_instance__["a" /* default */])({ timeout: 10000 });
var appClient = Object(__WEBPACK_IMPORTED_MODULE_0_helpers_create_axios_instance__["a" /* default */])({
  header: { clienttype: 'web' },
  timeout: 10000
});

var accumulateClient = Object(__WEBPACK_IMPORTED_MODULE_0_helpers_create_axios_instance__["a" /* default */])({ timeout: 10000 });

var stockStatisticsClient = Object(__WEBPACK_IMPORTED_MODULE_0_helpers_create_axios_instance__["a" /* default */])({ timeout: 10000 });

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dca1ecf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("kVxy");
function injectStyle (ssrContext) {
  __webpack_require__("zqsA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2dca1ecf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dca1ecf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__env_js__ = __webpack_require__("yZtZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_flexboxgrid_dist_flexboxgrid_min_css__ = __webpack_require__("siKq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_flexboxgrid_dist_flexboxgrid_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_flexboxgrid_dist_flexboxgrid_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_styl__ = __webpack_require__("7H/B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_plugin_config_v_touch__ = __webpack_require__("1aY9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_plugin_config_stock__ = __webpack_require__("hfZe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_plugin_config_toast__ = __webpack_require__("HARo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__plugins_business_api__ = __webpack_require__("xhNt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__plugins_market_proxy__ = __webpack_require__("P7WM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_create_deferred__ = __webpack_require__("6ecI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config__ = __webpack_require__("QmSG");



var loadJsBridge = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    var deferred;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            deferred = Object(__WEBPACK_IMPORTED_MODULE_13__helpers_create_deferred__["a" /* default */])();


            document.addEventListener('YTXBridgeReady', function () {
              window.YTXBridge ? deferred.resolve() : deferred.redirect();
            });

            return _context.abrupt('return', deferred.promise);

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function loadJsBridge() {
    return _ref.apply(this, arguments);
  };
}();

/* eslint-disable no-new */


// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// global js and css



// app and router



// plugin configuration



 // business 后端接口






__webpack_require__("hKoQ").polyfill();

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11__plugins_business_api__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12__plugins_market_proxy__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  stock: __WEBPACK_IMPORTED_MODULE_9_plugin_config_stock__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_6__App__["a" /* default */] },
  businessApi: new __WEBPACK_IMPORTED_MODULE_11__plugins_business_api__["a" /* default */](__WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].businessApi),
  marketProxy: new __WEBPACK_IMPORTED_MODULE_12__plugins_market_proxy__["a" /* default */](__WEBPACK_IMPORTED_MODULE_14__config__["a" /* default */].marketProxy),
  beforeCreate: function beforeCreate() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (window.YTXBridge) {
                _context2.next = 3;
                break;
              }

              _context2.next = 3;
              return loadJsBridge();

            case 3:
              window.YTXBridge.init(function () {});

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }))();
  }
});

/***/ }),

/***/ "OmHY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__client__ = __webpack_require__("LpSC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__map__ = __webpack_require__("AQnU");






var ws = void 0;

/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(symbol) {
    var _this = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { simple: true };
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var url, res, data, map;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = buildUrl(symbol, options);
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__client__["e" /* proxyClient */].get(url);

            case 3:
              res = _context.sent;
              data = res.data;
              map = options.simple ? __WEBPACK_IMPORTED_MODULE_4__map__["c" /* mapQuoteSimple */] : __WEBPACK_IMPORTED_MODULE_4__map__["b" /* mapQuote */];
              // return data

              return _context.abrupt('return', data.map(function (data) {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
                  symbol: data.symbol
                }, map(data.data));
              }));

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  gets: function gets(symbol) {
    var _this2 = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { simple: true };
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var url, res, data, map;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              url = buildUrls(symbol, options);
              _context2.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__client__["e" /* proxyClient */].get(url);

            case 3:
              res = _context2.sent;
              data = res.data;
              map = options.simple ? __WEBPACK_IMPORTED_MODULE_4__map__["b" /* mapQuote */] : __WEBPACK_IMPORTED_MODULE_4__map__["d" /* mapQuotes */];
              // return data

              return _context2.abrupt('return', data.map(function (data) {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
                  symbol: data.symbol
                }, map(data.data));
              }));

            case 7:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  connect: function connect(symbol, fn) {
    if (ws) ws.close();
    if (!window.WebSocket) return;
    var symbols = void 0;
    symbols = Array.isArray(symbol) ? symbol.map(function (symbol) {
      return 's_' + symbol;
    }) : ['s_' + symbol];

    ws = new window.WebSocket('wss://hq.sinajs.cn/wskt?list=' + symbols.join(','));
    ws.onmessage = function (event) {
      var stocks = event.data.split('\n').filter(function (data) {
        return !!data;
      }).map(function (stock) {
        return Object(__WEBPACK_IMPORTED_MODULE_4__map__["c" /* mapQuoteSimple */])(stock.split('=')[1]);
      });
      fn(stocks);
      ws.send('');
    };
  },
  close: function close() {
    if (ws) ws.close();
  }
});

function buildUrl(symbol, options) {
  if (Array.isArray(symbol)) {
    return '/hq.sinajs.cn/list=' + symbol.reduce(function (acc, val) {
      var url = options.simple ? 's_' + val : val;
      return acc + (acc ? ',' + url : '' + url);
    }, '');
  } else {
    return '/hq.sinajs.cn/list=' + (options.simple ? 's_' + symbol : symbol);
  }
}

function buildUrls(symbol, options) {
  if (Array.isArray(symbol)) {
    return '/hq.sinajs.cn/list=' + symbol.reduce(function (acc, val) {
      var url = options.simple ? 's_' + val : val;
      return acc + (acc ? ',' + url : '' + url);
    }, '');
  } else {
    symbol = symbol.replace(/h/, 'z');
    return '/hq.sinajs.cn/list=' + (options.simple ? 's_' + symbol : symbol + '_i');
  }
}

/***/ }),

/***/ "P7WM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__client__ = __webpack_require__("XuyG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__install__ = __webpack_require__("mJ9O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quote__ = __webpack_require__("icoh");




// 子模块


/**
 * xlgg market proxy
 * http://gitlab.yintech.net/ytx/paprika/NewBee/backend/xlgg-market-proxy/tree/master
 */

var MarketProxy = function MarketProxy(options) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, MarketProxy);

  if (MarketProxy.instance) {
    throw new Error('MarketProxy is singleton');
  }
  MarketProxy.instance = this;
  this.options = options;

  __WEBPACK_IMPORTED_MODULE_1__client__["a" /* default */].defaults.baseURL = options.baseURL;

  this.quote = __WEBPACK_IMPORTED_MODULE_3__quote__["a" /* default */];
};

/* harmony default export */ __webpack_exports__["a"] = (MarketProxy);


MarketProxy.instance = null;
MarketProxy.install = __WEBPACK_IMPORTED_MODULE_2__install__["a" /* default */];

/***/ }),

/***/ "QmSG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var config = {
  test: {
    stock: {
      sinaBaseURL: 'http://touzi.sina.com.cn/api/openapi.php',
      // proxyBaseURL: 'http://ywa-sina-proxy.api-zq-dev.baidao.com/build',
      proxyBaseURL: ' http://kong-http.api-zq-dev.baidao.com/sina-proxy/build',
      apiBaseURL: 'http://139.196.240.58:3800/api',
      appBaseURL: 'http://139.196.240.58:3002',
      // decodeBaseURL: 'http://ywa-sina-proxy.api-zq-dev.baidao.com/decode',
      decodeBaseURL: ' http://kong-http.api-zq-dev.baidao.com/sina-proxy/decode',
      // accumulateBaseURL: 'http://ywa-sina-proxy.api-zq-dev.baidao.com/accumulate'
      accumulateBaseURL: ' http://kong-http.api-zq-dev.baidao.com/sina-proxy/accumulate',
      stockStatisticsURL: 'http://139.196.240.58:3003'
    },
    businessApi: { // business 后端
      baseURL: 'http://kong-http.api-zq-dev.baidao.com/gmg-biz/v1'
    },
    marketProxy: {
      baseURL: 'http://kong-http.api-zq-dev.baidao.com/gmg-market'
    }
  },
  production: {
    stock: {
      sinaBaseURL: 'https://touzi.sina.com.cn/api/openapi.php',
      // proxyBaseURL: 'https://ywa-sina-proxy.baidao.com/build',
      proxyBaseURL: 'https://xlggapi.sinagp.com/sina-proxy/build',
      apiBaseURL: 'https://xltg-api.baidao.com/api',
      appBaseURL: 'https://xltg-stock.baidao.com',
      // decodeBaseURL: 'https://ywa-sina-proxy.baidao.com/decode',
      decodeBaseURL: 'https://xlggapi.sinagp.com/sina-proxy/decode',
      // accumulateBaseURL: 'https://ywa-sina-proxy.baidao.com/accumulate'
      accumulateBaseURL: 'https://xlggapi.sinagp.com/sina-proxy/accumulate',
      stockStatisticsURL: 'https://xltg-admin.baidao.com'
    },
    businessApi: {
      baseURL: 'https://xlggapi.sinagp.com/gmg-biz/v1'
    },
    marketProxy: {
      baseURL: 'https://xlggapi.sinagp.com/gmg-market'
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (config[window.env]);

/***/ }),

/***/ "QtBO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__client__ = __webpack_require__("LpSC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__quotes__ = __webpack_require__("OmHY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__install__ = __webpack_require__("A2jV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__diagnosis__ = __webpack_require__("SDHr");






var Stock = function Stock(options) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Stock);

  __WEBPACK_IMPORTED_MODULE_1__client__["f" /* sinaClient */].defaults.baseURL = options.sinaBaseURL;
  __WEBPACK_IMPORTED_MODULE_1__client__["e" /* proxyClient */].defaults.baseURL = options.proxyBaseURL;
  __WEBPACK_IMPORTED_MODULE_1__client__["b" /* apiClient */].defaults.baseURL = options.apiBaseURL;
  __WEBPACK_IMPORTED_MODULE_1__client__["d" /* decodeClient */].defaults.baseURL = options.proxyBaseURL;
  __WEBPACK_IMPORTED_MODULE_1__client__["c" /* appClient */].defaults.baseURL = options.appBaseURL;
  __WEBPACK_IMPORTED_MODULE_1__client__["a" /* accumulateClient */].defaults.baseURL = options.accumulateBaseURL;
  __WEBPACK_IMPORTED_MODULE_1__client__["g" /* stockStatisticsClient */].defaults.baseURL = options.stockStatisticsURL;
  this.quotes = __WEBPACK_IMPORTED_MODULE_2__quotes__["a" /* default */];
  this.diagnosis = __WEBPACK_IMPORTED_MODULE_4__diagnosis__["a" /* default */];
};

/* harmony default export */ __webpack_exports__["a"] = (Stock);


Stock.install = __WEBPACK_IMPORTED_MODULE_3__install__["a" /* default */];

/***/ }),

/***/ "SDHr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__client__ = __webpack_require__("LpSC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__map__ = __webpack_require__("AQnU");






/* harmony default export */ __webpack_exports__["a"] = ({
  getStarStocks: function getStarStocks() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var url, data;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = '/PerspectiveService.getStar';
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__client__["f" /* sinaClient */].get(url);

            case 3:
              data = _context.sent.data.result.data;
              return _context.abrupt('return', data.map(__WEBPACK_IMPORTED_MODULE_4__map__["f" /* mapStarStock */]));

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getStatistic: function getStatistic() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var total, today, res;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              total = '/PerspectiveService.getTotal';
              today = '/PerspectiveService.getToday';
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_3__client__["f" /* sinaClient */].get(total), __WEBPACK_IMPORTED_MODULE_3__client__["f" /* sinaClient */].get(today)]);

            case 4:
              res = _context2.sent;
              return _context2.abrupt('return', {
                total: res[0].data.result.data,
                today: res[1].data.result.data
              });

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  getHostestStock: function getHostestStock() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var url, data;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              url = '/PerspectiveService.getTodayHot';
              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__client__["f" /* sinaClient */].get(url);

            case 3:
              data = _context3.sent.data.result.data;
              return _context3.abrupt('return', data.map(__WEBPACK_IMPORTED_MODULE_4__map__["a" /* mapHotestStock */]));

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  search: function search(text) {
    var _this4 = this;

    var types = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['11'];
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var type, url, data, stocks;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              type = types.join(',');
              url = '/suggest3.sinajs.cn/suggest/type=' + type + '&key=' + text + '&name=suggestdata';
              _context4.next = 4;
              return __WEBPACK_IMPORTED_MODULE_3__client__["e" /* proxyClient */].get(url);

            case 4:
              data = _context4.sent.data.data;

              if (data) {
                _context4.next = 7;
                break;
              }

              return _context4.abrupt('return', []);

            case 7:
              stocks = data.split(';');
              return _context4.abrupt('return', stocks.map(__WEBPACK_IMPORTED_MODULE_4__map__["e" /* mapSearchResult */]));

            case 9:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  getEvaluation: function getEvaluation(symbol) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var url, data;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              url = 'PerspectiveService.diagnoseWap?symbol=' + symbol + '&';
              _context5.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__client__["f" /* sinaClient */].get(url);

            case 3:
              data = _context5.sent.data.result.data.data;
              return _context5.abrupt('return', data);

            case 5:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  },
  getTechnologyPerspective: function getTechnologyPerspective(symbol) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var url, data;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              url = 'TzyYKPerspectiveService.techPerspective?symbol=' + symbol;
              _context6.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__client__["f" /* sinaClient */].get(url);

            case 3:
              data = _context6.sent.data.result.data;
              return _context6.abrupt('return', data);

            case 5:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6);
    }))();
  },
  getCompareResult: function getCompareResult(symbol) {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var url, data;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              url = 'PerspectiveService.coefficientChart?type=wap&stock_code=' + symbol;
              _context7.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__client__["f" /* sinaClient */].get(url);

            case 3:
              data = _context7.sent.data.result.data.data;
              return _context7.abrupt('return', data);

            case 5:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this7);
    }))();
  },
  getPerspectiveChip: function getPerspectiveChip(symbol) {
    var _this8 = this;

    var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8() {
      var url, data;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              url = 'chipcompany?symbol=' + symbol + '&duration=' + duration;
              _context8.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__client__["e" /* proxyClient */].get(url);

            case 3:
              data = _context8.sent.data;
              return _context8.abrupt('return', data);

            case 5:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this8);
    }))();
  },
  getFinanceHq: function getFinanceHq(symbol) {
    var _this9 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9() {
      var url, data;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              url = 't2/finance.sina.com.cn/finance/hq/' + symbol + '.js';
              _context9.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__client__["e" /* proxyClient */].get(url);

            case 3:
              data = _context9.sent.data;
              return _context9.abrupt('return', data);

            case 5:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this9);
    }))();
  },
  getDailyData: function getDailyData(symbol) {
    var _this10 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10() {
      var url, data;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              url = '/finance.sina.com.cn/realstock/company/' + symbol + '/hisdata/klc_kl.js';
              _context10.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__client__["d" /* decodeClient */].get(url);

            case 3:
              data = _context10.sent.data;
              return _context10.abrupt('return', data);

            case 5:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this10);
    }))();
  },
  getBigDataStock: function getBigDataStock(symbol) {
    var _this11 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11() {
      var url;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              url = 'TzyYKPerspectiveService.bigPerspective?symbol=' + symbol;
              _context11.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__client__["f" /* sinaClient */].get(url);

            case 3:
              return _context11.abrupt('return', _context11.sent.data.result.data.res);

            case 4:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this11);
    }))();
  },
  getAchievement: function getAchievement(symbol) {
    var _this12 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12() {
      var url;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              url = 'TzyYKPerspectiveService.valuePerspective?symbol=' + symbol;
              _context12.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__client__["f" /* sinaClient */].get(url);

            case 3:
              return _context12.abrupt('return', _context12.sent.data.result.data.res);

            case 4:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this12);
    }))();
  },
  getCapitalResult: function getCapitalResult(symbol) {
    var _this13 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee13() {
      var url;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              url = 'TzyYKPerspectiveService.fundPerspective?symbol=' + symbol;
              _context13.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__client__["f" /* sinaClient */].get(url);

            case 3:
              return _context13.abrupt('return', _context13.sent.data.result.data.res);

            case 4:
            case 'end':
              return _context13.stop();
          }
        }
      }, _callee13, _this13);
    }))();
  },
  getFundInflow: function getFundInflow(symbol) {
    var _this14 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee14() {
      var url;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              url = 'stock.sina.com.cn/stock/api/jsonp.php/sz0000422017/TouziService.getStockHistoryMinuteFlow?symbol=' + symbol;
              _context14.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__client__["e" /* proxyClient */].get(url);

            case 3:
              return _context14.abrupt('return', _context14.sent.data);

            case 4:
            case 'end':
              return _context14.stop();
          }
        }
      }, _callee14, _this14);
    }))();
  },
  getBullBearDaily: function getBullBearDaily(symbol, duration) {
    var _this15 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee15() {
      var url;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              url = 'bscompany?symbol=' + symbol + '&duration=' + duration;
              // console.log(accumulateClient.defaults.baseURL)

              _context15.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__client__["a" /* accumulateClient */].get(url);

            case 3:
              return _context15.abrupt('return', _context15.sent.data);

            case 4:
            case 'end':
              return _context15.stop();
          }
        }
      }, _callee15, _this15);
    }))();
  },


  // 诊股统计
  stockStatistics: function stockStatistics(stockId, uid) {
    var _this16 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee16() {
      var url;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              url = '/admin/diagnosis';
              _context16.next = 3;
              return __WEBPACK_IMPORTED_MODULE_3__client__["g" /* stockStatisticsClient */].post(url, { uid: uid, stockId: stockId });

            case 3:
              return _context16.abrupt('return', _context16.sent.data);

            case 4:
            case 'end':
              return _context16.stop();
          }
        }
      }, _callee16, _this16);
    }))();
  }
});

/***/ }),

/***/ "V4B2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_create_axios_instance__ = __webpack_require__("+iUi");


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__helpers_create_axios_instance__["a" /* default */])());

/***/ }),

/***/ "XuyG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_create_axios_instance__ = __webpack_require__("+iUi");


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__helpers_create_axios_instance__["a" /* default */])());

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export routes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = [{
  name: 'diagnosis',
  path: '/diagnosis',
  component: function component(r) {
    return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("0C/n")]; ((r).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  },
  title: '大数据诊股'
}, {
  path: '/diagnosis/:symbol',
  name: 'diagnosis-result',
  title: '诊股结果',
  component: function component(r) {
    return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("dIWi")]; ((r).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}, {
  path: '/forbidden',
  name: 'forbidden',
  title: '无权限访问',
  component: function component(r) {
    return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Bj0M")]; ((r).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
  }
}];

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: routes
}));

/***/ }),

/***/ "ZEVD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
function install(Vue) {
  var BusinessApi = this;

  if (install.installed) return;
  install.installed = true;

  Object.defineProperty(Vue.prototype, '$businessApi', {
    get: function get() {
      return BusinessApi.instance;
    }
  });

  Vue.mixin({
    beforeCreate: function beforeCreate() {
      if (this.$options.businessApi) {
        this.businessApi = this.$options.businessApi;
      }
    }
  });
}

/***/ }),

/***/ "hfZe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plugins_stock__ = __webpack_require__("QtBO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("QmSG");



// import logger from 'vendor/logger'

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1__plugins_stock__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1__plugins_stock__["a" /* default */](__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */].stock));

/***/ }),

/***/ "icoh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__client__ = __webpack_require__("XuyG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_format__ = __webpack_require__("Kghx");





/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(symbol) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var res, data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__client__["a" /* default */].get('/quotes', { params: { symbols: symbol } });

            case 2:
              res = _context.sent;
              data = res && res.data && res.data.d && res.data.d[0] && res.data.d[0].v || {};
              return _context.abrupt('return', Object(__WEBPACK_IMPORTED_MODULE_3__helpers_format__["a" /* toCamel */])(data));

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),

/***/ "kVxy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mJ9O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
function install(Vue) {
  var MarketProxy = this;

  if (install.installed) return;
  install.installed = true;

  Object.defineProperty(Vue.prototype, '$marketProxy', {
    get: function get() {
      return MarketProxy.instance;
    }
  });

  Vue.mixin({
    beforeCreate: function beforeCreate() {
      if (this.$options.marketProxy) {
        this.marketProxy = this.$options.marketProxy;
      }
    }
  });
}

/***/ }),

/***/ "siKq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uDot":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__client__ = __webpack_require__("V4B2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_format__ = __webpack_require__("Kghx");





/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * 美股诊股
   * @param {*} symbol
   * http://gitlab.yintech.net/ytx/paprika/NewBee/backend/xlgg-biz-service/wikis/diagnosis/%E7%BE%8E%E8%82%A1%E8%AF%8A%E8%82%A1
   */
  get: function get(symbol, exchange, name) {
    var _this = this;

    var marketType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'CN';
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var res, data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__client__["a" /* default */].get('/diagnosis/gmg', { params: { ticker: symbol, exchange: exchange, name: name, marketType: marketType } });

            case 2:
              res = _context.sent;
              data = res && res.data && res.data.data || {};
              return _context.abrupt('return', Object(__WEBPACK_IMPORTED_MODULE_3__helpers_format__["a" /* toCamel */])(data));

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  getHottest: function getHottest() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var res, data;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return __WEBPACK_IMPORTED_MODULE_2__client__["a" /* default */].get('/diagnosis/gmg/hot');

            case 2:
              res = _context2.sent;
              data = res && res.data && res.data.data || {};

              data.forEach(function (item) {
                item.symbol = item.ticker;
              });
              return _context2.abrupt('return', data);

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  methods: {
    /**
     * initial rem
     */
    initDocumentFontSize: function initDocumentFontSize() {
      var resetFontSize = function resetFontSize() {
        var bodyWidth = document.body.clientWidth;
        var fontSize = bodyWidth >= 750 ? 100 : 100 * bodyWidth / 750;
        document.documentElement.style.fontSize = fontSize + 'px';
      };
      resetFontSize();
      window.addEventListener('load', function () {
        resetFontSize();
        window.timeOnPageStart = new Date();
      }, false);
      window.addEventListener('orientationchange', resetFontSize, false);
      window.addEventListener('resize', resetFontSize, false);
    }
  },
  created: function created() {
    this.initDocumentFontSize();
  }
});

/***/ }),

/***/ "xhNt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__client__ = __webpack_require__("V4B2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__install__ = __webpack_require__("ZEVD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__diagnosis__ = __webpack_require__("uDot");




// 子模块
// import room from './room'
// import professor from './professor'
// import chat from './chat'
// import video from './video'
// import course from './course'


/**
 * 公共后端业务聚合层
 * http://gitlab.yintech.net/ytx/paprika/NewBee/backend/xlgg-biz-service/wikis/pages
 */

var BusinessApi = function BusinessApi(options) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, BusinessApi);

  if (BusinessApi.instance) {
    throw new Error('BusinessApi is singleton');
  }
  BusinessApi.instance = this;

  this.options = options;

  __WEBPACK_IMPORTED_MODULE_1__client__["a" /* default */].defaults.baseURL = options.baseURL;

  // this.room = room
  // this.professor = professor
  // this.chat = chat
  // this.video = video
  // this.course = course
  this.diagnosis = __WEBPACK_IMPORTED_MODULE_3__diagnosis__["a" /* default */];
};

/* harmony default export */ __webpack_exports__["a"] = (BusinessApi);


BusinessApi.instance = null;
BusinessApi.install = __WEBPACK_IMPORTED_MODULE_2__install__["a" /* default */];

/***/ }),

/***/ "yZtZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isBindWechat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return userId; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_url__ = __webpack_require__("UZ5h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_url__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_querystring__ = __webpack_require__("1nuA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_querystring__);



var ip = /^\d{1,3}(\.\d{1,3}){3}$/g;

// URL 环境变量
var query = __WEBPACK_IMPORTED_MODULE_0_url___default.a.parse(window.location.toString(), true).query;

var queryParams = __WEBPACK_IMPORTED_MODULE_1_querystring___default.a.parse(window.location.search.slice(1));
var isBindWechat = queryParams.isBindWechat;
var userId = queryParams.userId;

// env
window.env = query.env ? query.env.replace('/', '') : undefined;
if (window.location.hostname === 'localhost') {
  window.env = 'test';
} else if (window.location.hostname.match(ip)) {
  window.env = 'test';
} else if (window.location.pathname.indexOf('demo') !== -1) {
  window.env = 'test';
} else {
  window.env = 'production';
}

function clearCookies() {
  var c = document.cookie.split('; ');
  for (var i in c) {
    document.cookie = /^[^=]+/.exec(c[i])[0] + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
  }
}

var noCache = query.nocache;
if (noCache) {
  clearCookies();
  window.localStorage.clear();
}

/***/ }),

/***/ "zqsA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.02c2c9f5771174869810.js